import { strings as Localization } from "../../lib/Localization"
import { setSearchQuery } from "../../redux/searchReducer"
import { useSearchQuery } from "../../redux/hook/searchHooks"
import { CustomTextField } from ".."
import { useSteering } from "../../redux/hook/userHooks"
import { clearSearchResult } from "../../redux/productReducer"
import { removeTrailingSlash } from "../../lib/helper/commonHelper"
import { setShowNavbarSearch } from "../../redux/settingsReducer"
import { useRouteMatch, Redirect } from "react-router-dom"
import { useDispatch } from "react-redux"

import SearchIcon from "@material-ui/icons/Search"
import React, { useEffect, useState } from "react"
import { Autocomplete, createFilterOptions } from "@material-ui/lab"
import { Box, makeStyles } from "@material-ui/core"

const useStyles = makeStyles(_theme => ({
    input: {
        fontSize: "1rem!important"
    }
}))

const AsyncSearch = ({ style, ...props }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [searchText, setSearchText] = useState("")
    const [query, setQuery] = useState("")
    const [redirect, setRedirect] = useState(false)
    const [selected, setSelected] = useState(null)

    const asyncSearchSearchQuery = useSearchQuery("asyncSearch")
    const steering = useSteering()
    const { url } = useRouteMatch()

    const handleEdit = e => {
        setSearchText(e.target.value)
    }

    const handleKeyUp = e => {
        if (e.keyCode === 13) {
            dispatch(setShowNavbarSearch(false))
            setRedirect(true)
        }
    }

    const handleSelect = (e, newSelectedOption) => {
        if (newSelectedOption === null) return

        setSelected(newSelectedOption)
        setRedirect(true)
    }

    useEffect(() => {
        if (Object.entries(asyncSearchSearchQuery).length > 0) {
            dispatch(clearSearchResult())
            searchOnText()
        }
    }, [steering])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setQuery(searchText)
        }, 750)

        return () => clearTimeout(delayDebounceFn)
    }, [searchText])

    useEffect(() => () => {
        setSelected(null)
        setRedirect(false)
    })

    const filterOptions = createFilterOptions({
        matchFrom: "any",
        stringify: option => (option.searchString)
    })

    const searchOnText = (ignoreSteering = false) => {
        const steeringFilter = { steering: [steering, "3"] }

        dispatch(setSearchQuery({
            type: "asyncSearch",
            value: (
                selected
                    ? {}
                    : {
                        texts: [searchText.trim()],
                        ...(ignoreSteering ? {} : steeringFilter)
                    }
            ),
            clearFilter: true
        }))
    }

    useEffect(() => {
        if (redirect) {
            // When the search term is a product number, ignore the steering.
            const isProductNumber = Boolean(
                searchText.trim().match(/^\d\d\d\d\d\d$/)
            )
            searchOnText(isProductNumber)
        }
    }, [searchText, selected, redirect, dispatch])

    return (
        <Box style={{ width: "inherit" }}>
            {
                (redirect) && (
                    selected
                        ? (<Redirect to={`${removeTrailingSlash(url)}/product/${selected.id}`} />)
                        : (<Redirect to={`${removeTrailingSlash(url)}/filter`} />)
                )
            }
            <Box
                style={{
                    display: "flex", gap: 10, paddingTop: 5, ...style
                }}
                {...props}
            >
                <SearchIcon />
                <Autocomplete
                    id="search"
                    style={{ flexGrow: 1 }}
                    open={open}
                    getOptionSelected={(option, value) => option.name === value.name}
                    getOptionLabel={option => `${option.id} ${option.name}`}
                    filterOptions={filterOptions}
                    onChange={handleSelect}
                    noOptionsText={Localization.searchForProducts}
                    options={options}
                    classes={{
                        input: classes.input,
                        listbox: classes.input
                    }}
                    autoSelect={false}
                    loadingText={Localization.loading}
                    clearOnEscape
                    popupIcon={null}
                    renderInput={params => (
                        <CustomTextField
                            {...params}
                            placeholder={Localization.searchUpperCase}
                            variant="standard"
                            onChange={e => handleEdit(e)}
                            onKeyUp={e => handleKeyUp(e)}
                            InputProps={{
                                ...params.InputProps
                            }}
                        />
                    )}
                />
            </Box>
        </Box>
    )
}

export default AsyncSearch
